// extracted by mini-css-extract-plugin
module.exports = {"notification":"bUHO1p","icon":"s53Ri6","buttonContent":"z_7aLP"};